import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Auth from '../../store/actions/auth/Auth';
import authActions from '../../store/actions/auth';
import ErrorIcon from '../../assets/img/ErrorIcon.svg';

const Callback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const error = useSelector(state => state.auth.error);

  useEffect(() => {

    dispatch(authActions.handleAuthentication((err, result) => {
      if (err) {
        console.error('Authentication error:', err);
        return;
      }
      if (!result.smsCode) {
        const returnUrl = result.returnUrl ? encodeURIComponent(result.returnUrl) : '/';
        navigate(`/mfa/?returnUrl=${returnUrl}`);
        return;
      } else if (result.returnUrl) {
        if (
          !result.returnUrl.includes('admin') &&
          Auth.hasScopes([
            'deliveries:send-to-customer',
            'deliveries:receive-from-customer'
          ])
        ) {
          navigate('/admin/');
        } else {
          navigate(result.returnUrl);
        }
      } else {
        navigate('/');
      }
    }));
  }, [navigate, dispatch]);

  if (error) {
    return (
      <div className="result-page">
        <img src={ErrorIcon} alt="Error" className="result-icon" />
        <p className="result-message result-message--error">
          {error}
        </p>
      </div>
    );
  }

  return (
    <div className="result-page">
      <p>Processing authentication...</p>
    </div>
  );
};

export default Callback;